// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__lS6Uk","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2kro_","obliqueLine":"membershipbadge_obliqueLine__amv4i"};